import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';
import { QUERY_KEYS } from '@/utils/query-keys';

interface UseCreateResolution886AssessmentParams {
	organization_id: string;
	company_id: string;
	review_id: string;
	activity_id: string;
	file_id: string;
}

const Service = Resolution886ReportService.getInstance();

export function useCreateResolution886Assessment() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: UseCreateResolution886AssessmentParams) => Service.createAssessment(params),
		onSuccess: (result) => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_RESOLUTION_886_ASSESSMENT_LIST]);
			return result;
		},
		onError: () => {
			message.error(I18n.get('Error creating assessment'));
		}
	});
}
